import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'svg[mib-stroke-width-icon]',
  template: `
    <svg:path
      d="M1.4375 13.5781V12.2656H14.5625V13.5781H1.4375ZM1.4375 9.90625V7.9375H14.5625V9.90625H1.4375ZM1.4375 5.70312V2.42188H14.5625V5.70312H1.4375Z" />
  `,
  host: {
    '[attr.viewBox]': 'viewBox()',
    class: 'mib-icon-default-size fill-current transition-colors',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StrokeWidthIcon {
  readonly viewBox = input<string>('0 0 16 16');
}
